var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"k-header-date"},[_c('div',{staticClass:"year"},[_vm._v(_vm._s(_vm._f("moment")(this.date,'YYYY'))+" ")]),_c('div',{staticClass:"mounth"},[_vm._v(" "+_vm._s(_vm._f("moment")(this.date,'ddd, DD MMM'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }